<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="pXIV"></a><img alt="Hannibal" src="images/map1.jpg"/></p>
<p class="caption"><a id="map1"></a><b>Map 1</b> The central Mediterranean: Carthage, Rome and Sicily</p>
<p class="image"><a id="pXV"></a><img alt="Hannibal" src="images/map2.jpg"/></p>
<p class="caption"><a id="map2"></a><b>Map 2</b> The western Mediterranean</p>
<p class="image"><a id="pXVI"></a><img alt="Hannibal" src="images/map3.jpg"/></p>
<p class="caption"><a id="map3"></a><b>Map 3</b> Carthage and environs</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// maps.vue?b7211ade